import {
  ApiBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

import { contextRouterApiRef } from './api/types';
import { ContextRouterClient } from './api/ContextRouterClient';
import { rootRouteRef } from './routes';

const contextRouterApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: contextRouterApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new ContextRouterClient({ discoveryApi, fetchApi }),
    }),
});

const contextRouterPage = PageBlueprint.make({
  params: {
    path: '/context-router',
    title: 'Context Router',
    routeRef: rootRouteRef,
    // The page renders its own BUI <FullPage>/<Header>.
    noHeader: true,
    loader: () =>
      import('./components/ContextRouterPage').then(m => (
        <m.ContextRouterPage />
      )),
  },
});

export const contextRouterPlugin = createFrontendPlugin({
  pluginId: 'context-router',
  title: 'Context Router',
  routes: {
    root: rootRouteRef,
  },
  extensions: [contextRouterApi, contextRouterPage],
});

export default contextRouterPlugin;
